module.exports = __webpack_public_path__ + "static/media/eye.b877f4ed.svg";